import React from 'react';
import { ClickAwayListener } from '@mui/material';
import { Button } from '../Button/Button';
import css from './CompleteRequestDialog.module.scss';

interface CompleteRequestDialogProps {
    setIsCompleteDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isErrorDialog: boolean;
    headerText: string;
    successText: string;
    errorText: string;
    closeButtonText: string;
    onClose?: () => void; // Optional callback for custom close actions
}

export const CompleteRequestDialog: React.FC<CompleteRequestDialogProps> = ({
    setIsCompleteDialogOpen,
    isErrorDialog,
    headerText,
    successText,
    errorText,
    closeButtonText,
    onClose,
}) => (
    <div className={css.darkBackground}>
        <ClickAwayListener
            onClickAway={() => {
                setIsCompleteDialogOpen(false);
                onClose && onClose();
            }}
        >
            <div className={css.completeDialog}>
                <div className={css.dialogHeader}>{headerText}</div>
                <div className={css.dialogText}>
                    {isErrorDialog ? errorText : successText}
                    <div className={css.dialogButtonContainer}>
                        <Button
                            variant="primary"
                            onClick={() => {
                                setIsCompleteDialogOpen(false);
                                onClose && onClose();
                            }}
                        >
                            {closeButtonText}
                        </Button>
                    </div>
                </div>
            </div>
        </ClickAwayListener>
    </div>
);
